import { useAuth } from "contexts/AuthContext";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// Role-targeted dashboard components — each is already self-contained
// (no MD2 examples wrappers). The shared DashboardShell in App.js provides
// the sidebar + top bar + page padding.
import AdminDashboard from "./components/AdminDashboard";
import PastorDashboard from "./components/PastorDashboard";
import StaffDashboard from "./components/StaffDashboard";
import MemberDashboard from "./components/MemberDashboard";
import TreasurerDashboard from "./components/TreasurerDashboard";
import SuperAdminDashboard from "layouts/super-admin";

export default function Dashboard() {
  const { user } = useAuth();

  switch (user?.role) {
    case "super_admin":
      return <SuperAdminDashboard />;
    case "admin":
    case "branch_admin":
      return <AdminDashboard />;
    case "pastor":
      return <PastorDashboard />;
    case "staff":
      return <StaffDashboard />;
    case "member":
      return <MemberDashboard />;
    case "treasurer":
      return <TreasurerDashboard />;
    case "department_head":
    case "ministry_head":
      return <MemberDashboard />;
    default:
      return (
        <Box sx={{ textAlign: "center", py: 8 }}>
          <Typography variant="h5">Welcome to Ecclesia</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Please contact your administrator for dashboard access.
          </Typography>
        </Box>
      );
  }
}
